import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemRevisionModel from "../../../models/ItemRevisionModel";
import DataService from "../../../services/data.service";
import { DataResult } from "../../../types/Result";

interface CreateBillOfMaterialsModel {
    itemRevisionId: number
    billOfMaterialTemplateId?: number
    supplierBusinessPartnerId?: number
}

interface ItemRevisionPopupProps {
    show: boolean
    onHide: () => void
    itemRevision: ItemRevisionModel
}

const CreateBillOfMaterialsPopup: React.FC<ItemRevisionPopupProps> = ({ show, onHide, itemRevision }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<CreateBillOfMaterialsModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<CreateBillOfMaterialsModel>({
        itemRevisionId: itemRevision.id,
    });

    const suppliers = useSelectListOptions('api/v1/selectlist/BusinessPartnersForItem?itemId=' + itemRevision.itemId + '&businessPartnerTypeId=2', '-- Select supplier');
    const templates = useSelectListOptions('api/v1/selectlist/BillOfMaterialsTemplates?itemTypeId=' + itemRevision.item.itemTypeId, '-- Select template');

    function submit() {
        if (formData) {
            DataService
                .create<CreateBillOfMaterialsModel>(`api/v1/BillOfMaterials`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'supplierBusinessPartnerId', label: 'Supplier', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
            { name: 'billOfMaterialTemplateId', label: 'Template', labelSize: 4 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Create Bill-of-Materials for a supplier'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('supplierBusinessPartnerId')} options={suppliers} />
                <SelectListField {...getFieldProps('billOfMaterialTemplateId')} options={templates} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default CreateBillOfMaterialsPopup;